/**
 * View for the KB creator wizard
 */
define([
  "marionette",
  "modules/accountAdmin/kbWizardModal/template/kbWizardModalTemplate.html",
], function (Marionette, KbWizardModalTemplate) {
  var KbWizardModalView = {};

  KbWizardModalView.kbWizardModalLayout = Marionette.Layout.extend({
    template: KbWizardModalTemplate,
    regions: {
      kbWizardStep: "#kbWizardStep",
      kbWizardPane: "#kbWizardPane",
    },
    triggers: {
      "click #backButton": "back",
      "click #nextButton": "next",
      "click #doneButton": "done",
      "click #cancelButton": "cancel",
    },
    hideBackButton: function () {
      this.$el.find("#backButton").hide();
    },
    showBackButton: function () {
      this.$el.find("#backButton").show();
    },
    hideNextButton: function () {
      this.$el.find("#nextButton").hide();
    },
    showNextButton: function () {
      this.$el.find("#nextButton").show();
    },
    toggleNextButton: function (enabled) {
      enabled ? this.$el.find("#nextButton").show() : this.$el.find("#nextButton").hide();
    },
    toggleDoneButton: function (enabled) {
      this.$el.find("#doneButton").prop("disabled", !enabled);
    },
    hideDoneButton: function () {
      this.$el.find("#doneButton").hide();
    },
    showDoneButton: function () {
      this.$el.find("#doneButton").show();
    },
    hideCancelButton: function () {
      this.$el.find("#cancelButton").hide();
    },
    showCancelButton: function () {
      this.$el.find("#cancelButton").show();
    },
  });

  return KbWizardModalView;
});
